import React from "react";
import { brl } from "../../lib/format";
import { Check } from "lucide-react";

const DEFAULT_ITEMS = [
  { d: "Serviço principal", q: 1, v: 3500 },
  { d: "Configuração e ajustes", q: 1, v: 1200 },
  { d: "Suporte (30 dias)", q: 1, v: 800 },
];

// Lightweight, premium A4 quote mockup (not the real editor sheet).
export default function PdfPreview({
  brand = "Estúdio Norte",
  headerLabel = "Orçamento",
  title = "Proposta Comercial",
  client = "Maria Santos",
  items = DEFAULT_ITEMS,
  accent = "#0f172a",
  signed = false,
  compact = false,
  className = "",
  style = {},
}) {
  const total = items.reduce((a, it) => a + it.q * it.v, 0);
  const pad = compact ? "p-4 sm:p-5" : "p-6 sm:p-7";
  return (
    <div
      className={`keep-light relative bg-white rounded-xl ring-1 ring-slate-200/80 shadow-[0_30px_70px_-30px_rgba(15,23,42,0.35)] overflow-hidden ${pad} ${className}`}
      style={{ aspectRatio: "1 / 1.414", ...style }}
      data-testid="pdf-preview"
    >
      {/* header */}
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-2.5">
          <span className="grid place-items-center rounded-lg text-white font-bold shrink-0" style={{ background: accent, width: 34, height: 34 }}>
            {brand.slice(0, 1)}
          </span>
          <div className="leading-tight">
            <div className="text-[12px] font-bold text-slate-900 tracking-tight">{brand}</div>
            <div className="text-[9px] text-slate-400">contato@empresa.com</div>
          </div>
        </div>
        <div className="text-right">
          <div className="text-[9px] font-semibold uppercase tracking-[0.18em]" style={{ color: accent }}>{headerLabel}</div>
          <div className="text-[9px] text-slate-400 mt-0.5 font-mono-jb">#0042</div>
        </div>
      </div>

      <div className="mt-4 h-px" style={{ background: `linear-gradient(90deg, ${accent}22, transparent)` }} />

      {/* client + title */}
      <div className="mt-4">
        <div className="text-[8px] uppercase tracking-wider text-slate-400">Para</div>
        <div className="text-[12px] font-semibold text-slate-800">{client}</div>
        <div className="mt-3 text-[15px] font-bold text-slate-900 tracking-tight leading-snug">{title}</div>
      </div>

      {/* items */}
      <div className="mt-4 rounded-lg ring-1 ring-slate-100 overflow-hidden">
        <div className="flex items-center justify-between px-3 py-1.5" style={{ background: `${accent}0d` }}>
          <span className="text-[8px] font-semibold uppercase tracking-wider text-slate-500">Descrição</span>
          <span className="text-[8px] font-semibold uppercase tracking-wider text-slate-500">Total</span>
        </div>
        {items.map((it, i) => (
          <div key={i} className="flex items-center justify-between px-3 py-2 border-t border-slate-50">
            <span className="text-[10px] text-slate-600 truncate pr-2">{it.d}</span>
            <span className="text-[10px] font-mono-jb text-slate-800 shrink-0">{brl(it.q * it.v)}</span>
          </div>
        ))}
      </div>

      {/* totals */}
      <div className="mt-3 flex justify-end">
        <div className="w-40 rounded-lg px-3 py-2 flex items-center justify-between" style={{ background: accent }}>
          <span className="text-[9px] font-semibold uppercase tracking-wider text-white/70">Total</span>
          <span className="text-[12px] font-bold text-white font-mono-jb">{brl(total)}</span>
        </div>
      </div>

      {/* signature */}
      <div className="absolute left-6 right-6" style={{ bottom: 22 }}>
        <div className="flex items-end justify-between">
          <div>
            <div className="w-28 border-t border-slate-300 pt-1 text-[9px] text-slate-500">{brand}</div>
          </div>
          {signed && (
            <div className="inline-flex items-center gap-1 rounded-full bg-emerald-50 ring-1 ring-emerald-200 px-2 py-1" data-testid="pdf-signed-stamp">
              <span className="grid place-items-center w-3.5 h-3.5 rounded-full bg-emerald-500 text-white"><Check size={9} strokeWidth={4} /></span>
              <span className="text-[8px] font-semibold text-emerald-700">Assinado digitalmente</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
